/**
 *  版权所有 © 2026 东方闻道 All Rights Reserved
 *
 *  创建者: chen
 *  创建时间: 2026-06-26 15:40
 *  文件名: src/pages/Home/common.ts
 *  功能描述:
 */
export enum MenuType {
  Resource = 0, // 资源
  Notice = 1, // 公告
}

// 公告类型
export const NoticeType = 0;

export interface MenuItem {
  id: string;
  columnId?: string; // 假设字段名是 columnId
  name: string;
  children?: MenuItem[];
  type: string | null;
  config: string | null;
  // 其他字段...
}

// 单个权限配置
export interface ColumnPermission {
  createPermissions: number[];
  syncGradeCodes: string[];
  syncSubjectCodes: string[];
  schoolPeriods: string[];
  matchAll: boolean;
}

// 或者使用 Record 工具类型
export type ColumnPermissionMap = Record<string, ColumnPermission>;

export function getMatchedPermissionsList(
  menus: MenuItem[],
  permissions: ColumnPermissionMap,
): Array<{ menu: MenuItem; permission: { syncGradeCodes: string[] } }> {
  const result: Array<{ menu: MenuItem; permission: { syncGradeCodes: string[] } }> = [];
  const permissionIds = new Set(Object.keys(permissions));

  function traverse(items: MenuItem[]) {
    for (const item of items) {
      if (item.columnId && permissionIds.has(item.columnId)) {
        result.push({
          menu: item,
          permission: permissions[item.columnId],
        });
      }
      if (item.children?.length) {
        traverse(item.children);
      }
    }
  }

  traverse(menus);
  return result;
}
